exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remind-mes{width:30px!important;height:14px!important;line-height:14px;text-align:center;margin-left:8px;white-space:nowrap;background:#3394e1;color:#fff;border-radius:0 26px 26px 0}.fs-10,.remind-mes{display:inline-block}.fs-10{font-size:10px;-webkit-font-size:12px;-webkit-transform:scale(.8)}", ""]);

// exports
